<template>
  <div class="diagnosis_lightbox">
    <div class="dLinghtbox_show">
      <section>
        <p>{{ title }}</p>
        <img
          class="img-responsive"
          :src="loadImg"
          :alt="title"
        />
      </section>
      <ul class="dia_timeBar timelineBar list-unstyled">
        <step
          :description="description.desc1"
          step="one"
          :styleClass="{
            styleMain: {step: true, success: true, hidden: isGreen}
          }">
        </step>
        <step
          componentName="DiagnosisMotorBatteryStep"
          :batteryRlt="batteryRlt"
          :description="description.desc2"
          :status="description.status"
          step="two"
          :percent="seconds"
          :time="time"
          :styleClass="{
            styleMain: {step: true, 'step-bar-none-finish': isHide, error: isError, active: isActive, success: isSuccess},
            styleStatus: {error: isError, success: isSuccess}
          }">
        </step>
        <step
          :description="description.desc3"
          step="three"
          :styleClass="{
            styleMain: {step: true, 'hidden': isHide}
          }">
        </step>
      </ul>
    </div>
    <div class="dLinghtbox_control">
      <Operator
        :btnText="{up: '', down: btnCancel, power: btnStep}"
        :isHidePower="isHidePower"
        @keyDownEvent="funcHandleDown('cancel')"
        @keyPowerEvent="funcHandlePower(btnStep)"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Operator from './Operator';
import Step from './Step';
import { allowPartNo, funcOriginalPartNo } from '@/utils/allowPartNo';
import { funcGetHealthLevel } from '@/utils/batteryHealth';

export default {
  name: 'DiagnosisMotorBatteryStep',
  props: [
    'modalOpen',
    'title',
    'itemId',
    'seconds',
    'btn',
    'bikeVal',
    'content',
    'bikeStatus',
    'bikeErrorCode'
  ],
  components: {
    Operator,
    Step
  },
  data () {
    return {
      description: {
        desc1: '',
        desc2: this.content.step1,
        desc3: this.content.step2,
        status: ''
      },
      btnStep: this.btn,
      btnCancel: 'Cancel',
      isGreen: true,
      isHide: false,
      isError: false,
      isActive: true,
      isSuccess: false,
      isHidePower: false,
      btnName: ['Start', '', 'Finish'],
      btnNext: {
        step1: 'start',
        step2: 'processing',
        step3: 'finish'
      },
      diagnosisName: 'motorbattery',
      count: 0,
      interval: null,
      time: false,
      percent: 0,
      batteryRlt: ''
    };
  },
  mounted () {
    this.$bus.$on('powerClick', (data) => {
      // 暫時這樣設定，當power是disabled防止用戶在bike console操作
      if (this.isHidePower) return;
      this.funcHandlePower(this.btnStep);
    });
  },
  beforeDestroy () {
    this.$bus.$off('powerClick');
  },
  watch: {
    content: {
      handler: function () {
        this.funcStepDefault();
      },
      immediate: true
    },
    modalOpen (val) {
      // 如果關閉modal
      this.btnStep = this.$t('diagnosis.btnStep.start');
      this.btnCancel = this.$t('diagnosis.btnStep.cancel');
      if (!val) {
        this.funcStepDefault();
      }
    },
    bikeStatus (val) {
      if (val === 1000) this.percent = 100;
      if (val === 1001) this.percent = 100;
    },
    percent (val) {
      if (val === 100) this.funcStepOne();
    },
    count (val) {
      /**
       * step1: start,0
       * step2: processing,1
       * step3: finish,2
       */
      // console.log(this.count)
      switch (this.btnNext[this.step[val]]) {
        case 'finish':
          this.funcStepTwo();
          break;
      }
    }
  },
  computed: {
    ...mapGetters({
      getDeviceInfo: 'bikeConnect/getDeviceInfo',
      getAllBikeInfoList: 'bikeInformation/getAllBikeInfoList'
    }),
    loadImg () {
      switch (this.itemId) {
        case 'diagnosisDriver':
          return require('@/assets/images/diagnosis/img_driver.jpg');
        case 'diagnosisMotor':
          var strPhtoName = this.getMotorImgOfPartNo();
          return require(`@/assets/images/diagnosis/${strPhtoName}`);
        case 'diagnosisBattery':
          return require('@/assets/images/diagnosis/img_battery_rear.jpg');
        default:
          return require('@/assets/images/diagnosis/no_image.jpg');
      }
    },
    step () {
      return Object.keys(this.btnNext);
    },
    stepName () {
      return this.btnNext[this.step[this.count]];
    }
  },
  methods: {
    /** 用 PN 找到對應的圖片 */
    getMotorImgOfPartNo () {
      const partNo = funcOriginalPartNo(this.getDeviceInfo.DriverPN);
      var photo = '';
      let allowPart = allowPartNo[partNo];
      if (allowPart) {
        photo = allowPartNo[partNo].motorPhoto;
      } else {
        photo = 'no_image.jpg';
      }
      return photo;
    },
    funcStepOne () {
      this.isGreen = false;
      this.time = true;
      this.funcDiagnosisContent(
        this.content.step1,
        this.content.step4,
        this.content.step3
      );
      if (this.percent === 100) {
        setTimeout(() => {
          this.isHidePower = false;
          this.count++;
        }, 1000);
      } else this.isHidePower = true;
    },
    funcStepTwo () {
      this.isGreen = false;
      this.isHide = true;
      this.time = false;
      this.btnCancel = '';

      if (this.bikeStatus === 1000 && this.percent === 100) {
        this.isActive = false;
        this.isSuccess = true;

        this.funcDiagnosisContent(
          `${this.seconds} ${this.content.step4}`,
          this.content.step5,
          ''
        );
        this.description.status = this.content.step6;
        this.btnStep = this.content.step3;
        if (this.itemId === 'diagnosisBattery') {
          let batLanguageID = funcGetHealthLevel(this.getAllBikeInfoList.bikeBatteryInfo.Health);
          this.batteryRlt = 'SOH ' + this.$t('bikeOverview.bikeInformation.eBike.battery.health.' + batLanguageID);
        }
        this.$store.dispatch('diagnosis/changeDiagnosisMotorBattery', { title: this.itemId, result: true, errorCode: this.bikeErrorCode.ErrorCodeBike });
      } else if (this.bikeStatus === 1001 && this.percent === 100) {
        // alert(this.bikeStatus)
        this.batteryRlt = '';
        this.isActive = false;
        this.isSuccess = false;
        this.isError = true;

        this.funcDiagnosisContent(
          'No signal',
          this.content.step5,
          ''
        );

        this.description.status = this.content.step7;
        this.btnStep = this.content.step3;
        this.$store.dispatch('diagnosis/changeDiagnosisMotorBattery', { title: this.itemId, result: false, errorCode: this.bikeErrorCode.ErrorCodeBike });
      }
    },
    funcStepDefault () {
      //  UI 显示
      this.isActive = true;
      this.isError = false;
      this.isSuccess = false;
      this.isHide = false;
      this.isHidePower = false;
      this.isGreen = true;
      //  UI 显示 end
      this.funcDiagnosisContent(
        '',
        this.content.step1,
        this.content.step2
      );

      this.description.status = '';
      this.count = 0;
      this.time = false;
      this.batteryRlt = '';
    },
    funcDiagnosisContent (c1, c2, c3) {
      this.description.desc1 = c1;
      this.description.desc2 = c2;
      this.description.desc3 = c3;
    },
    percentTo100 () {
      this.interval = setInterval(() => {
        this.percent += 10;
        if (this.percent >= 100) {
          clearInterval(this.interval);
          // console.log('close keep connect => diagnosis m&b line241')
        }
      }, 500);
    },
    funcHandleDown (key) {
      clearInterval(this.interval);
      // console.log('close keep connect => diagnosis m&b line247')
      this.percent = 0;
      this.$emit('keyDownEvent', key);
    },
    funcHandlePower (power) {
      clearInterval(this.interval);
      // console.log('close keep connect => diagnosis m&b line253')
      this.percent = 0;
      /**
       * 特殊情況：count是2最後一個步驟
       * 2<3 count++，造成stepName是undefined
       * */
      if (this.count < this.step.length && this.stepName !== 'finish') {
        this.count++;
      }
      switch (this.stepName) {
        case 'processing':
          this.funcStepOne();
          break;
      }
      this.$emit('keyPowerEvent', { name: this.diagnosisName, action: this.stepName });
    }
  }
};
</script>
